module.exports = __webpack_public_path__ + "img/HLB0224.8a288a59.png";